import React from 'react';
import { ExternalLink, LogOut } from 'lucide-react';
import BrandMark from '../../components/BrandMark';
import { useContent } from '../../content/ContentContext';
import AdminTabs from './AdminTabs';

export default function AdminHeader({ title = '管理后台', viewHref = '/', viewLabel = '看网站', onLogout, maxWidth = 'max-w-6xl' }) {
  const { site = {} } = useContent();
  const brandName = site.brandName || '加太教育';
  return (
    <header className="sticky top-0 z-20 border-b border-gray-200 bg-white">
      <div className={`mx-auto flex ${maxWidth} items-center justify-between gap-4 px-4 py-3`}>
        <div className="flex items-center gap-2.5">
          <BrandMark size="sm" />
          <div className="font-bold text-slate-900 max-sm:hidden">{brandName} · {title}</div>
        </div>
        <AdminTabs />
        <div className="flex items-center gap-2">
          {viewHref && (
            <a href={viewHref} target="_blank" rel="noreferrer" className="inline-flex items-center gap-1 rounded-lg px-3 py-2 text-sm font-medium text-gray-600 hover:bg-gray-100 max-sm:hidden">
              <ExternalLink className="h-4 w-4" /> {viewLabel}
            </a>
          )}
          {onLogout && (
            <button onClick={onLogout} className="inline-flex items-center gap-1 rounded-lg px-3 py-2 text-sm font-medium text-gray-600 hover:bg-gray-100 cursor-pointer">
              <LogOut className="h-4 w-4" /> 退出
            </button>
          )}
        </div>
      </div>
    </header>
  );
}
